import { Stack } from "@mui/material";
import { Step } from "@/pages/reservations/hooks/useSteps";
import { useOutletContext } from "react-router-dom";
import StepSummary from "@/pages/reservations/components/ConfirmationView/components/StepSummary";

const ConfirmationView = () => {
    const { steps } = useOutletContext<{ steps: Step[] }>();
    
    return (
        <Stack spacing={3}>            
            {steps.map((step) => (
                <StepSummary step={step} />
            ))}
        </Stack>
    )
}

export default ConfirmationView;
